export default "__VITE_ASSET__BhMqlZAE__"